import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { Form } from '@rocketseat/unform';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { store } from '~/store';
import { toggleLoading } from '~/store/modules/main/actions';
import { toggleModal } from '~/store/modules/modal/actions';

import Button from '../../components/Button';
import api from '../../services/api';
import { ContainerForm, Header, InputResume, CustomDiv } from './styles';

function FormSetores({ data: dados, setRefresh }) {
  const [data] = useState(dados.dataLoad);
  const { profile: userData } = store.getState().user;

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const schema = Yup.object().shape({
    id: Yup.mixed(),
    nome: Yup.string().required('O campo Nome do Setor é obrigatório'),
  });

  const handleSubmit = async formData => {
    dispatch(toggleLoading(true));
    let save = {};
    if (!formData.id) {
      save = await api.post('setores', { ...formData, dataCadastro: new Date(), usuarioCadastro: userData.id });
    } else {
      save = await api.put('setores', {
        ...formData,
        dataAlteracao: new Date(),
        usuarioAlteracao: userData.id,
      });
    }

    const { status, message } = save.data;
    if (status) {
      enqueueSnackbar(message, { variant: 'success' });
      setRefresh(refresh => !refresh);
      dispatch(toggleModal(false, null, null, null));
    } else {
      enqueueSnackbar(message, { variant: 'error' });
    }
    dispatch(toggleLoading(false));
  };

  return (
    <ContainerForm>
      <Header>
        <h1>Setor</h1>
        <span>Administração de setores</span>
      </Header>
      <Form onSubmit={handleSubmit} initialData={data} schema={schema}>
        <InputResume id="id" name="id" style={{ display: 'none' }} />
        <CustomDiv>
          <label htmlFor="nome">Nome do Setor</label>
          <InputResume name="nome" id="nome" maxLength={250} />
        </CustomDiv>
        <Button handleClick={() => {}} text="Salvar" backColor="#5b5c65" color="#FFF" style={{ marginTop: '10px', right: '0' }} />
      </Form>
    </ContainerForm>
  );
}

FormSetores.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  setRefresh: PropTypes.func.isRequired,
};

export default FormSetores;
